import styled from 'styled-components';

export const StyledIotListBox = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 220px;
  min-width: 220px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(146, 255, 192, 0.3);
  box-shadow: 0px 10px 15.3px 0px rgba(13, 175, 160, 0.4) inset;

  .box-wrapper {
    padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #040404;
    position: relative;
    cursor: pointer;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 252px;
      height: 1px;
      background: rgba(146, 195, 255, 0.3);
      transform: translateX(-50%);
    }

    &.active {
      background: var(--main-gradient);
      border-bottom: none;
    }

    .title {
      color: var(--color-white);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .count {
      color: var(--color-white);
      text-align: right;
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;

      .ea {
        color: var(--color-white);
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }
  }
`;
